import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'title', label: 'Title', type: 'text' },
    { key: 'source', label: 'Source / Awarding body', type: 'text' },
    { key: 'date', label: 'Date', type: 'text' },
    {
        key: 'type',
        label: 'Type',
        type: 'select',
        options: [
            { value: 'award', label: 'Award' },
            { value: 'media', label: 'Media' },
        ],
    },
    {
        key: 'media_category',
        label: 'Media / Award Category',
        type: 'select',
        hint: 'Determines which tab on the Media & Awards page this appears under.',
        options: [
            { value: 'news_coverage', label: 'News Coverage' },
            { value: 'print_media', label: 'Print Media' },
            { value: 'tv_coverage', label: 'Television Coverage' },
            { value: 'awards', label: 'Awards & Recognitions' },
            { value: 'appreciation', label: 'Appreciation Certificates' },
            { value: 'media_gallery', label: 'Media Gallery' },
        ],
    },
    { key: 'image_url', label: 'Image', type: 'upload-image', prefix: 'media-awards' },
    { key: 'link', label: 'External link', type: 'text' },
    { key: 'description', label: 'Description', type: 'textarea', rows: 2 },
    { key: 'order', label: 'Order', type: 'number' },
];

const CATEGORY_LABELS = {
    news_coverage: 'News',
    print_media: 'Print',
    tv_coverage: 'TV',
    awards: 'Award',
    appreciation: 'Appreciation',
    media_gallery: 'Gallery',
};

const columns = [
    { key: 'title', label: 'Title', primary: true },
    { key: 'source', label: 'Source' },
    {
        key: 'media_category',
        label: 'Category',
        render: (r) => CATEGORY_LABELS[r.media_category] || r.type,
    },
    { key: 'date', label: 'Date' },
];

const defaultItem = {
    title: '',
    source: '',
    date: '',
    type: 'media',
    media_category: 'news_coverage',
    image_url: '',
    link: '',
    description: '',
    order: 99,
};

export default function AdminMediaAwardsPage() {
    return (
        <CrudManager
            resource="media-awards"
            title="Media & Awards"
            description="Recognition and press coverage, grouped into 6 categories on the public site."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['title', 'source']}
        />
    );
}
